import { PayloadAction } from '@reduxjs/toolkit';
import { openVkBuyModalWithSidebar } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.helpers';
import { EPaymentModalType } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.types';
import { openFastCheckout } from 'reactApp/modules/payment/payment.module';
import { OpenFastCheckoutAction } from 'reactApp/modules/payment/payment.types';
import { updateProducts } from 'reactApp/modules/products/products.module';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { initPromoTariffs } from 'reactApp/modules/promoTariffs/promoTariffs.saga';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { waitForUserUpdate } from 'reactApp/modules/user/waitForUserUpdate';
import { channel } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';

function* openFastCheckoutModal(action: PayloadAction<OpenFastCheckoutAction>) {
    const { productId, onSuccess, afterUpdate, onClose } = action.payload;

    if (!productId) {
        yield call(initPromoTariffs, {});
    }

    const product = yield select(ProductsSelectors.getPrimaryProduct, productId);

    if (!product) {
        yield put(
            showSnackbarAction({
                type: SnackbarTypes.failure,
                id: 'file-upload-err',
                text: 'Нет доступных тарифов',
                closable: true,
            })
        );
        return;
    }

    const fastCheckoutChannel = channel();

    yield openVkBuyModalWithSidebar({
        onSuccess: () => fastCheckoutChannel.put(true),
        onClose: () => {
            onClose?.();
            fastCheckoutChannel.close();
        },
        productId: product.id,
        type: EPaymentModalType.fastcheckout,
    });

    const isSuccess = yield take(fastCheckoutChannel);

    if (isSuccess) {
        yield onSuccess?.();
        yield put(updateProducts());
        yield waitForUserUpdate();
        yield afterUpdate?.();
    }
}

export function* watchPayment() {
    yield takeEvery(openFastCheckout.toString(), openFastCheckoutModal);
}
